module.exports = __webpack_public_path__ + "img/profile.a8cb1864.jpg";